import dynamic from "next/dynamic";

export const ClientsCarousel = dynamic(() => import("./component"));
